<template>
    <div>
        <div class="dataTitle">
            <div class="title">{{title}}</div>
            <div style="display: flex;justify-content: center;align-items: center;">
                <InputField label="" type="text" label-width="0%" id="sewagePlant" style="margin-right: 1rem;"
                            :modelValue="preForm.sewagePlant" placeholder="请输入污水厂名称"
                            @update:modelValue="(value) => handleModelPreValueUpdate('sewagePlant', value)"/>
                <a-space>
                    <ButtonField style="width: 80px;" text="查询" secondary @click="getWwtPlantOpPageList"/>
                    <ButtonField style="width: 80px;" text="新增" @click="add" primary />
                </a-space>
            </div>
        </div>
        <Tablelist
            :showCheckbox="false"
            :list="list"
            :columns="tableColumns"
            :totalSize="preForm.totalSize"
            :totalPages="preForm.totalPages"
            :pageNum="preForm.pageNum"
            :pageSize="preForm.pageSize"
            @page-change="onChange"
        >
            <template v-slot:actions="{ item }">
                <a-space>
                    <a href="#" @click.prevent="editText(item)">编辑</a>
                    <a href="#" class="danger" @click.prevent="deleteText(item)">删除</a>
                </a-space>
            </template>
        </Tablelist>
        <Modal v-if="visible" v-model="visible"
               :visible="visible"
               :title="editShow?'编辑污水处理厂运行':'新增污水处理厂运行'"
               :showFooter="false"
               :overlayOpacity="0.5"
               :contentWidth="'50%'"
               @update:visible="visible = $event">
            <form>
                <div class="formDiv">
                    <div>
                        <InputField label="污水厂名称" type="text"  id="sewagePlant" labelWidth="80%"
                                    :modelValue="form.sewagePlant" placeholder="请输入污水厂名称"  required
                                    @update:modelValue="(value) => handleModelValueUpdate('sewagePlant', value)"/>
                    </div>
                    <div>
                        <InputField label="设计处理能力(万吨/日)" type="text"  id="capacity" labelWidth="80%"
                                    :modelValue="form.capacity" placeholder="请输入设计处理能力(万吨/日)"
                                    @update:modelValue="(value) => handleModelValueUpdate('capacity', value)"/>
                    </div>
                </div>
                <div class="formDiv">
                    <div>
                        <InputField label="实际处理水量(万吨/日)" type="Number"  id="waterYield" labelWidth="80%"
                                    :modelValue="form.waterYield" placeholder="请输入实际处理水量(万吨/日)"
                                    @update:modelValue="(value) => handleModelValueUpdate('waterYield', value)"/>
                    </div>
                    <div>
                        <InputField label="进水COD(mg/L)" type="Number"  id="inflowCOD" labelWidth="80%"
                                    :modelValue="form.inflowCOD" placeholder="请输入进水COD(mg/L)"
                                    @update:modelValue="(value) => handleModelValueUpdate('inflowCOD', value)"/>
                    </div>
                </div>
                <div class="formDiv">
                    <div>
                        <InputField label="进水氨氮(g/L)" type="Number"  id="inflowNHN" labelWidth="80%"
                                    :modelValue="form.inflowNHN" placeholder="请输入进水氨氮(g/L)"
                                    @update:modelValue="(value) => handleModelValueUpdate('inflowNHN', value)"/>
                    </div>
                    <div>
                        <InputField label="粗格栅前液位(米)" type="Number"  id="liquidLevel" labelWidth="80%"
                                    :modelValue="form.liquidLevel" placeholder="请输入粗格栅前液位(米)"
                                    @update:modelValue="(value) => handleModelValueUpdate('liquidLevel', value)"/>
                    </div>
                </div>

                <div style="display: flex;justify-content: center;">
                    <a-space>
                        <ButtonField text="关闭" @click="cancel" secondary />
                        <ButtonField text="保存" v-if="!saveShow" primary @click="handleSubmit"/>
                        <ButtonField text="下一步" v-else primary @click="handleNextStep"/>
                    </a-space>
                </div>
            </form>
        </Modal>
    </div>
</template>

<script>
import {
    saveWwtPlantOpPage,
    modifyWwtPlantOpPage,
    remove, fetchWwtPlantOpPageList,
} from "@/views/diagnose/api/diagnose";

export default {
    name: "index",
    data() {
        return {
            preForm:{
                totalSize: 1,
                totalPages: 1,
                pageNum: 1,
                pageSize: 10,
            },

            form:{
                sewagePlant:null,capacity:null,waterYield:null,inflowCOD:null,inflowNHN:null,liquidLevel:null
            },
            visible:false,
            editShow:false,
            saveShow:false,
            list:[],
            tableColumns:[
                {key: 'sewagePlant',title: '污水厂名称',field: 'sewagePlant',width: '100px'},
                {key: 'capacity',title: '设计处理能力（万吨/日）',field: 'capacity',width: '100px'},
                {key: 'waterYield',title: '实际处理水量（万吨/日）',field: 'waterYield',width: '100px'},
                {key: 'inflowCOD',title: '进水COD（mg/L）',field: 'inflowCOD',width: '100px'},
                {key: 'inflowNHN',title: '进水氨氮（mg/L）',field: 'inflowNHN',width: '100px'},
                {key: 'liquidLevel',title: '粗格栅前液位（米）',field: 'liquidLevel',width: '100px'},
                {key: 'actions',title: '操作',field: 'actions', infotype: 'template',width: '100px'},
            ]
        }
    },
    props:{
        title: {
            type: String,
            default: null,
        },
    },
    mounted() {
        this.getWwtPlantOpPageList();
    },
    methods: {
        formatDate(dateString){
            const date = new Date(dateString);
            return date.toISOString().split('T')[0];
        },
        onChange(pagination) {
            this.preForm.pageNum  = pagination;
            this.preForm.pageSize = 10;
            this.getWwtPlantOpPageList();
        },
        getWwtPlantOpPageList(){
            fetchWwtPlantOpPageList(this.preForm).then(res => {
                this.list = res.list.map(item => ({
                    ...item,
                    daytime: this.formatDate(item.daytime)
                }));
                this.preForm.totalPages = res.totalPages;
                this.preForm.totalSize = res.totalSize;
            })
        },
        handleModelPreValueUpdate(fieldName, value){
            this.preForm[fieldName] = value;
        },
        handleModelValueUpdate(fieldName, value) {
            this.form[fieldName] = value;
        },
        add(){
            this.visible = true;
            this.editShow = false;
            this.saveShow = false;
            this.form = {}
        },
        editText(item){
            console.log("item:::",item)
            this.visible = true;
            this.editShow = true;
            this.saveShow = false;
            this.form = item;
        },
        deleteText(item){
            console.log("item:::",item)
            remove({
                id: item.id,
                type: "diagnose_wwt_plant_op"
            }).then((res) => {
                console.log("res:", res);
                this.getWwtPlantOpPageList();
            }).catch((error) => {
                console.error("删除失败:", error);
            });
        },
        cancel() {
            this.visible = false;
        },
        handleSubmit(){
            this.form.daytime = new Date();
            if(this.form.id){
                modifyWwtPlantOpPage(this.form).then(res => {
                    console.log("modifyUnderSurfGrnPage   res:::",res)
                    this.getWwtPlantOpPageList()
                })
            }else{
                saveWwtPlantOpPage(this.form).then(res => {
                    console.log("saveUnderSurfGrnPage   res:::",res)
                    this.getWwtPlantOpPageList()
                })
            }
            this.saveShow = true
        },
        handleNextStep(){
            this.visible = false;
            this.$bus.$emit('switch-component', 'underSurfGrn');
        }
    }
}
</script>
<style scoped>
.dataTitle{
    display: flex;
    justify-content: space-between;
    align-content: center;
    margin:0 0 1rem 0;
}
.title{
    font-size: 1.2rem;
    color: #00ff96;
    font-weight: bold;
}
.formDiv{
    display: flex;
    justify-content: space-between;
    margin: 1rem 0;
}
.formDiv > div{
    width: 48%;
}
</style>